export default __webpack_public_path__ + "static/mansiFull-108720233895d304fcd5886e57102760.svg";